function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18",
  height: "18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M13.499 11.878c1.092.548 2.028 1.428 2.711 2.53.135.217.203.326.226.477.048.307-.162.684-.447.805-.141.06-.3.06-.615.06m-3.375-7.1a3.375 3.375 0 000-6.05m-1.5 3.025a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm-8.58 8.579C3.113 12.408 5 11.25 7.123 11.25s4.01 1.158 5.205 2.954c.262.393.393.59.378.84a.832.832 0 01-.296.554c-.2.152-.477.152-1.03.152H2.866c-.552 0-.828 0-1.029-.152a.831.831 0 01-.296-.553c-.015-.251.116-.448.378-.841z",
  stroke: "currentColor",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));